import * as yup from 'yup';

export const notesValidation = yup.string().max(500);
export const referenceIdValidation = yup.string().max(90);
const URLRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;

export const createTransferValidation = yup.object().shape({
    referenceId: yup.string().max(90, "Order ID must be at most 90 characters.").required("Order ID is required").matches(/[^\s]+/, 'Spaces are not allowed'),
    storeURL: yup.string().matches(URLRegex, 'Please enter valid URL').matches(/[^\s]+/, 'Spaces are not allowed'),
    buyerName: yup.string().max(90, "Buyer name must be at most 90 characters.").required("Buyer name is required").matches(/[^\s]+/, 'Spaces are not allowed'),
    buyerPhone: yup.string().matches(/^\d{10}$/, 'Enter valid phone number').required('Phone number is required'),
    buyerEmail: yup.string().email('Enter valid email address').required('Email is required').matches(/[^\s]+/, 'Spaces are not allowed'),
    modelType: yup.string().max(90, "Model type must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    street: yup.string().max(90, "Street must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    city: yup.string().max(90, "City must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    state: yup.string().max(90, "State must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    zipCode: yup.string().min(5, "Enter valid Zip code.").max(5, "Enter valid Zip code."),
    notes: yup.string().max(500, "Notes must be at most 500 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
});


export const regexFullLicense = /^(\d)-?(\d\d)-?[\d]{3}-?[\d]{2}-?[\d]{1}[a-zA-Z]{1}-?(\d\d\d\d\d)$/;
export const licenseApprovalValidation = yup.object().shape({
    full_license_key: yup.string().required("License number is required.").matches(regexFullLicense, "Enter valid license number."),
    printed_name: yup.string().min(1, "").max(90, "Name must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed.'),
    position_title: yup.string().min(1, "").max(90, "Title must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed.')
});
export const customAddressValidation = yup.object().shape({
    street: yup.string().min(1, "").max(90, "Street must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed').required(),
    city: yup.string().min(1, "").max(90, "City must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed').required(),
    state: yup.string().min(1, "").max(90, "State must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed').required(),
    zipcode: yup.string().min(1, "").length(5, "Enter valid zip code.").required()
});

export const manageDealerProfileValidation = yup.object().shape({
    full_license_key: yup.string().required("License number is required.").matches(regexFullLicense, "Enter valid license number."),
    email: yup.string().trim().required("Email is required"),   
    domain: yup.string().trim().matches(/^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,11}$/, "Invalid domain name").required("Enter domain name!")
});

export const manageParametersValidation = yup.object().shape({
    waiting_period_of_dealer_action: yup.number()
        .integer("Waiting period of dealer action must be an integer.")
        .required("Dealer action timeout is required.")
});

export const manageTermsAndConditions = yup.object().shape({ terms_and_condition: yup.string() });